export default {
  path: 'users',
  name: 'users',
  redirect: { name: 'users.listing' },
  component: () => import(/* webpackChunkName: "auth" */ '@/views/Home/Users'),
  children: [
    {
      path: '/',
      name: 'users.listing',
      component: () =>
        import(/* webpackChunkName: "users" */ '@/views/Home/Users/UserList')
    },
    {
      path: '/users/:id',
      name: 'user.details',
      component: () =>
        import(/* webpackChunkName: "users" */ '@/views/Home/Users/UserDetails')
    }
  ]
}
